import { gql } from '@apollo/client'

export const GET_EVENT_CONFIRM_BY_EMAIL = gql`
    query EventConfirmByEmail($guid: String!) {
        entity(guid: $guid) {
            guid
            ... on Event {
                title
                url
                attendees {
                    total
                    totalAccept
                }
                maxAttendees
                enableMaybeAttendEvent
                attendEventOnline
                isFormEnabled
                form {
                    __typename @include(if: false)
                    title
                    description
                    formFields {
                        __typename @include(if: false)
                        guid
                        title
                        description
                        fieldType
                        isMandatory
                        fieldOptions
                    }
                }
            }
        }
    }
`
